<template>
  <div>
    <x-grid :id="'childGrid'"
            :columns="columns"
            :toolbar-config="toolbarConfig"
            :editable="true"
            :edit-rules="editRules"
            :editConfig="editConfig"
            ref="grid"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
        <vxe-button @click="add">新增</vxe-button>
        <vxe-button @click="delRow()">删除</vxe-button>
      </template>
    </x-grid>
    <div>
      <a-icon type="question-circle"/>
      完成阶梯所需助力人数获得对应奖励，最多支持三阶。每个好友只能助力一次，删除再添加无效
    </div>
  </div>
</template>

<script>
import XGrid from '@/components/grid/XGridChild'
import {GridChildMixin} from "@/utils/GridChildMixin";
import {
  formatter as fmt
} from "@/utils/ebase-formatter"

const fac = XGrid.factory;
console.info(fmt);//防止不使用便利 eslint报错

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumn({
    field: "prizeRank",
    title: "阶梯等级",
    width: 120,
    editRender: {
      name: 'input'
    },
  }),
  fac.makeColumn({
    field: "assistCount",
    title: "助力人数",
    width: 120,
    editRender: {
      name: 'input',
      props: {
        max: 10000,
        min: 0,
        type: 'integer'
      }
    },
  }),
  fac.makeColumn({
    field: "prizeName",
    title: "奖品名称",
    width: 260,
    editRender: {
      name: 'input',
      attrs: {
        maxlength: 10
      }
    },
  }),
  fac.makeColumn({
    field: "prizeCount",
    title: "奖品数量",
    width: 120,
    editRender: {
      name: 'input',
      props: {
        max: 10000,
        min: 0,
        type: 'integer'
      }
    },
  }),
]

//可编辑表格规则 没有特殊要求的不改
const editRules = fac.makeEditRules(columns);
//工具栏按钮 没有可删除
const toolbarConfig = fac.makeToolbarConfig({
  templatelSlots: 'toolbarBtns'
});
//编辑配置
const editConfig = fac.makeEditConfig();

export default {
  mixins: [GridChildMixin],
  data() {
    return {
      editRules,
      columns,
      toolbarConfig,
      editConfig,
    }
  },
  methods: {
    add() {
      this.getChildData((child) => {
        if (child.length >= 3) {
          this.$message.error('阶梯等级最多为三级')
          return false
        } else {
          this.addRow()
        }
      });
    }
  }
}
</script>

<style scoped>
.vxe-toolbar {
  padding-left: 0
}

/deep/ .vxe-table {
  height: 192px;
  overflow: hidden;
}
</style>